import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated/dist/react-select-animated.cjs';
import useDiscussionsClubsHostsInternalHosts from '../../../hooks/useDiscussionsClubsHostsInternalHosts';
import axios from 'axios';
import { globalURLS } from '../../../Global/urls';
import { useGlobalContext } from '../../../Context';

interface Discussion {
    discussionid: string;
}

interface EndLiveProps {
    show: boolean;
    onHide(): void;
}

interface ISelectDiscussion {
    value: string;
    label: string;
}

const animatedComponents = makeAnimated();

const initialData: Discussion = {
    discussionid: '',
};

const EndLive: React.FC<EndLiveProps> = ({ show, onHide }) => {
    const [Discussion, setDiscussion] = useState<Discussion>(initialData);
    const [selectDiscussions, setSelectDiscussions] = useState<
        ISelectDiscussion[]
    >([{ value: '', label: '' }]);
    const { setShowSuccessToast, setShowErrorToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchSelectDiscussions = async () => {
            try {
                const res = await axios.post(
                    `${globalURLS.baseURL}ADgetDiscussionsLive`,
                    globalURLS.config,
                );

                if (res?.data?.success === true) {
                    setSelectDiscussions(res?.data?.data);
                }
            } catch (error) {
                console.log('---err', error);
            }
        };

        fetchSelectDiscussions();
    }, []);

    const handlerSubmit = async () => {
        try {
            setIsLoading(true);
            const res = await axios.post(
                `${globalURLS.baseURL}endLiveDiscussion`,
                {
                    discussionid: Discussion?.discussionid,
                },
                globalURLS.config,
            );

            setIsLoading(false);

            if (res?.data?.success === true) {
                onHide();
                setDiscussion(initialData);
                setShowSuccessToast(true);
            } else {
                setShowErrorToast(true);
            }
        } catch (error) {
            console.log(error);
            setShowErrorToast(true);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>End Live Discussion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="discussionid">
                        <Form.Label>Discussion</Form.Label>
                        <Select
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            onChange={(val: any) =>
                                setDiscussion({
                                    ...Discussion,
                                    discussionid: val.value,
                                })
                            }
                            isSearchable
                            options={JSON.parse(
                                JSON.stringify(
                                    selectDiscussions ? selectDiscussions : [],
                                ),
                            )}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button
                    variant="danger"
                    disabled={isLoading}
                    onClick={handlerSubmit}
                >
                    End Live
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EndLive;
